declare const re_local_url: string;

export class URLProcessor{
	constructor (
		protected $: JQueryStatic
	){
	}

	protected setURLParams(selection, match, attribute, getVars: Map<string, string>) {
		if (!selection.length)
			return;
		let proc = this;
		selection.each(function () {
			let url = $(this).attr(attribute);

			if (!(url && url.match(re_local_url)))
				return;

			let ap = url.split('#');
			let qs = ap[0].split('?');
			let new_url = qs[0];
			let new_get = [];
			if (qs.length > 1){
				for (let get of qs[1].split('&'))
					if (!get.match(match))
						new_get.push(get);
			}
			getVars.forEach(function (val:string, get:string) {
				new_get.push(get+'='+val);
			});

			new_url += '?' + new_get.join('&');
			if (ap.length > 1)
				new_url += '#' + ap[1];
			proc.$(this).attr(attribute, new_url);
		});
	}

	setGET(getVars: Map<string, string>, elements?: Map<string, string>){
		if (elements === undefined)
			elements = new Map([
				['a', 'href'],
				['form', 'action']
			]);
		let g = [];

		getVars.forEach((v:string, k:string) => {
			g.push(k);
		});
		let match_get = new RegExp('^('+g.join('|')+')=');
		elements.forEach((attr:string, elem:string) => {
			this.setURLParams(this.$(elem), match_get, attr, getVars);
		});
	}
}



// WEBPACK FOOTER //
// ./src/script/app/URL.ts